package org.moxultimate.topwithmox.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import org.moxultimate.topwithmox.components.layouts.PageLayoutData
import org.moxultimate.topwithmox.wallpaper.ui.WallpaperPage

@InitRoute
fun initWallpaperRoute(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData("Free 4K & 8K Wallpapers"))
}

@Page
@Layout(".components.layouts.PageLayout")
@Composable
fun WallpaperRoute() {
    WallpaperPage()
}
